import React, { Component, Fragment } from 'react';
import DragWidthCom from '../DragWidthCom';
import DragHeightCom from '../DragHeightCom';
import './index.less';

class DragLayoutCom extends Component {
    constructor(props) {
        super(props);
    }
    static defaultProps = {
        defLeftWid: "360",
        leftMinWid: 50,
        topMinHeight:50,
        verAside: 'top', //垂直展开方向
        horAside: 'right', //水平展开方向
        showVerDragLine: true, //上下拖拽线
        showHorDragLine: true, //左右拖拽线
        verExpandFlag: true, //垂直展开
        horDefaultExpandFlag: false, //水平默认展开
        verDefaultExpandFlag: false, //垂直默认展开
        visible: true,
        showVerArea: true, //显示上下分栏,
        showHorArea: true, //显示水平分栏
        showHorExpandBtn: true, //显示水平分栏按钮
        showVerExpandBtn: true, //显示垂直分栏按钮
        useHeightPosition: true, // 使用定位优化展开收起动画
    }

    render() {
        let { 
            isLowCode,
            defLeftWid, 
            defTopHeight, 
            leftMinWid, 
            topMinHeight,
            leftDomNode, 
            rightDomNode, 
            topDomNode, 
            bottomDomNode, 
            children,
            verAside,  
            horAside,
            verExpandFlag,
            horDefaultExpandFlag,
            verDefaultExpandFlag,
            showVerArea,
            showHorArea,
            bottomClassName,
            showVerDragLine,
            showHorDragLine,
            onHorExpand,
            onVerExpand,
            onHorDragStop,
            onVerDragStop,
            expandFlag,
            showHorExpandBtn,
            useHeightPosition,
            ...otherProps
        } = this.props;

        if (!Number.isNaN(Number(defLeftWid))) {
            defLeftWid = Number(defLeftWid) + "px";
        }
        if (!Number.isNaN(Number(defTopHeight))) {
            defTopHeight = Number(defTopHeight) + "px";
        }
        if (!Number.isNaN(Number(leftMinWid))) {
            leftMinWid = Number(leftMinWid) + "px";
        }
        if (!Number.isNaN(Number(topMinHeight))) {
            topMinHeight = Number(topMinHeight) + "px";
        }
        let bottomArea = <Fragment>{children}{bottomDomNode}</Fragment>;

        const leftDom = (
            <div className='horiz-container'>
                <div className='left'>{leftDomNode}</div>
                <div className='vert-container'>
                    <DragHeightCom
                        {...otherProps}
                        aside={verAside}
                        showExpandBtn={showVerArea ? true: false}
                        showDragLine={showVerArea ? showVerDragLine: false}
                        defaultExpandFlag={showVerArea ? verDefaultExpandFlag: false}
                        topDom={topDomNode}
                        bottomDom={bottomArea}
                        defTopHeight={defTopHeight}
                        topMinHeight={topMinHeight}
                        bottomClassName={bottomClassName}
                        onExpand={onVerExpand}
                        onDragStop={onVerDragStop}
                        showVerArea={showVerArea}
                        usePosition={useHeightPosition}
                    />
                </div>
            </div>
        );
        return (
            <DragWidthCom
                {...otherProps}
                leftDom={leftDom}
                rightDom={rightDomNode}
                defLeftWid={defLeftWid}
                leftMinWid={leftMinWid}
                aside={horAside}
                defaultExpandFlag={showHorArea ? horDefaultExpandFlag: false}
                showDragLine={showHorArea? showHorDragLine: false}
                showExpandBtn={showHorArea ? true: showHorExpandBtn}
                maxDragWidth="half"
                minDragWidth={360}
                bottomClassName={bottomClassName}
                onExpand={onHorExpand}
                onDragStop={onHorDragStop}
                showHorArea={showHorArea}
                usePosition={useHeightPosition}
                cacheWidth={true}
            />
        );
    }
}
export default DragLayoutCom;